/**
 * @module use-cases/app/actions
 * @desc App Action Creators
 *
 */

import { TLocationState } from 'core/domains/router';

import { Loader } from 'core/domains/app';
import { TMenuItems, TrackClick } from 'core/middlewares/trackingGA4/@types';
import { createAction } from 'core/use-cases/utilities';
import type { Notification, Location, Settings } from 'core/domains';

export const preflightFlow = createAction<'@@preflightFlow', boolean>('@@preflightFlow');

export const appInitFlow = createAction<'@@appInitFlow'>('@@appInitFlow');

export const hideNotification = createAction<'hideNotification', Notification['id']>(
  'hideNotification',
);

export const setScreenSize = createAction<'setScreenSize'>('setScreenSize');

export const showNotification = createAction<'showNotification', Notification>('showNotification');

export const toggleCart = createAction<'toggleCart', boolean>('toggleCart');

export const toggleMenu = createAction<'toggleMenu', boolean>('toggleMenu');

export const toggleProductNotFoundShipping = createAction<'toggleProductNotFoundShipping', boolean>(
  'toggleProductNotFoundShipping',
);

export const toggleSearch = createAction<'toggleSearch', boolean>('toggleSearch');

export const toggleShipping = createAction<'toggleShipping', boolean>('toggleShipping');

export const togglePointsProgram = createAction<'togglePointsProgram', boolean>(
  'togglePointsProgram',
);

export const trackClick = createAction<'trackClick', TrackClick>('trackClick');

export const setLoading = createAction<'setLoading', Loader['message']>('setLoading');

export const setLocation = createAction<'setLocation', Location>('setLocation');

export const setBreadcrumbs = createAction<
  'setBreadcrumbs',
  {
    homePage: string;
    currentState: TLocationState;
    routes: Settings['data']['routes'];
  }
>('setBreadcrumbs');

export const onClickTooltip = createAction<'@@onClickTooltip', string>('@@onClickTooltip');

export const trackMenuClick = createAction<'trackMenuClick', TMenuItems>('trackMenuClick');

export const homeBanner = createAction<
  'homeBanner',
  { position: number; type?: 'select' | 'view' }
>('homeBanner');

export const refetchBreadcrumbs = createAction<'refetchBreadcrumbs', string>('refetchBreadcrumbs');

export const canLoadVWO = createAction<'canLoadVWO'>('canLoadVWO');
